import {WalkOfShame} from "../WalkOfShame";
import {WalkOfShameSymbolState} from "./WalkOfShameSymbolConfig";
import {IBaseSymbol} from "../../core/symbol/BaseSymbol";
import {WalkOfShameGameConfig} from "../WalkOfShameGameConfig";
import {TimelineLite, gsap} from "gsap";
import {WalkOfShameHelper} from "../../core/utils/WalkOfShameHelper";
import {WalkOfShameReelView} from "../reels/WalkOfShameReelView";
import {ArrayHelper} from "@nolimitcity/slot-game/bin/utils/ArrayHelper";

export class WalkOfShameSymbol extends PIXI.spine.Spine implements IBaseSymbol {
    public symbolWidth: number = 144;
    public symbolHeight: number = 148;
    public symbolName: string;
    public reelId: number;
    private _centerPosition: PIXI.Point;
    private _stateTl: TimelineLite | null;

    constructor(symbolName: string, reelId: number, initState: WalkOfShameSymbolState) {
        super(WalkOfShame.assetLoader.getSpineAsset(symbolName));
        this.symbolName = symbolName;
        this.reelId = reelId;
        this.initAnimation();
        this.getStateAnimation(initState);
    }

    public get symbolStep(): number {
        return this.symbolHeight;
    }

    public getStateAnimation(state: WalkOfShameSymbolState): TimelineLite {
        const tl: TimelineLite = new TimelineLite();

        this.killStateTl();

        state = this.checkForStateChange(state);

        tl.add(this._stateTl = WalkOfShameHelper.createTimelineForAnimation(this, 0, state, (state === WalkOfShameSymbolState.ANTICIPATION)));

        return tl;
    }

    public getShakeAnimation(duration: number): TimelineLite {
        const tl: TimelineLite = new TimelineLite,
            wiggles = ArrayHelper.shuffle([WalkOfShameGameConfig.bigWinAnticipationWiggle, WalkOfShameGameConfig.bigWinAnticipationWiggle2]),
            x: string = Math.random() > 0.5 ? "-=2" : "+=2",
            y: string = Math.random() > 0.5 ? "-=1" : "+=1";

        if (this.symbolName === "S") {
            return tl;
        }

        tl.to(this.position, {
            duration: duration,
            x: x,
            ease: wiggles[0]
        });
        tl.to(this.position, {
            duration: duration,
            y: y,
            ease: wiggles[1]
        }, "<");
        tl.to(this, {
            duration: duration,
            rotation: 0.1,
            ease: wiggles[1]
        }, "<");

        return tl.reverse();
    }

    // #136
    public killStateTl(): void {
        if (this._stateTl) {
            this._stateTl.kill();
            this._stateTl = null;

            gsap.killTweensOf(this);
        }
    }

    public onRemove(): void {
        this.killStateTl();

        this.destroy({children: true});
    }

    public replaceSymbol(newName: string, initState: WalkOfShameSymbolState): WalkOfShameSymbol {
        const newSymbol: WalkOfShameSymbol = new WalkOfShameSymbol(newName, this.reelId, initState),
            oldSymIdx: number = WalkOfShame.reels[this.reelId].reelView.allSymbols.indexOf(this),
            reelView: WalkOfShameReelView = WalkOfShame.reels[this.reelId].reelView;

        reelView.addSymbol(newSymbol);
        newSymbol.position = this.position;
        reelView.allSymbols[oldSymIdx] = newSymbol;
        reelView.moveToTop(newSymbol);

        if (initState === WalkOfShameSymbolState.FULL) {
            newSymbol.y = 273 + 25;
        }

        this.parent.removeChild(this);

        return newSymbol;
    }

    private initAnimation(): void {
        this._centerPosition = this.getCenterPosition();
        this.position.set(this._centerPosition.x, this._centerPosition.y - (this.symbolHeight / 2));
    }

    private getCenterPosition(): PIXI.Point {
        return new PIXI.Point(0, 0);
    }

    private checkForStateChange(state: WalkOfShameSymbolState): WalkOfShameSymbolState {
        // overriding for spin during scatters anticipations
        if (state === WalkOfShameSymbolState.SPIN && WalkOfShameGameConfig.IS_ANTICIPATING) {
            // do nothing -> keep it Scatter or Scatter2
            if (this.symbolName.indexOf("S") > -1) {
                state = WalkOfShameSymbolState.NORMAL;
            } else {
                state = WalkOfShameSymbolState.SPIN_DIM;
            }
        }
        // overriding for empty spin during WALK animation
        else if (state === WalkOfShameSymbolState.SPIN && !WalkOfShameGameConfig.WALK_COMPLETED) {
            state = WalkOfShameSymbolState.EMPTY;
        }

        return state;
    }
}